import { useState, useEffect, useMemo } from 'react';
import { ethers, BigNumber, utils } from 'ethers';
import { Box, Flex, Image, Input, UnorderedList, ListItem, useMediaQuery } from '@chakra-ui/react';
import abi from '../abi.json';
import mainImg from '../assets/mainImage.gif';
import ButtonPress from './ButtonPress';

const contractAddress = '0x75239771A2A5d01677a5D3154F7Ed60152fa5572';

const MainMint = ({ accounts, setAccounts}) => {

    const [mintAmount, setMintAmount] = useState(20);
    const [priceContract, setPriceContract] = useState(null);
    const isConnected = Boolean(accounts[0]);
    const [isLargerThan550] = useMediaQuery('(min-width: 550px)');
    const [isLargerThan800] = useMediaQuery('(min-width: 800px)');

    async function getPrice() {

        const RPC = process.env.REACT_APP_INFURA_LINK;
        const provider = new ethers.providers.JsonRpcProvider(RPC);
        const contract = new ethers.Contract(contractAddress, abi, provider);
        const result = await contract.price();
        const price = utils.formatEther(result);
        return price;
    }

    const listItem = useMemo(() => {
        if (priceContract > 0) {
          return (
            <ListItem>Price: {priceContract}</ListItem>
          );
        } else {
          return (
            <ListItem>Free Mint</ListItem>
          );
        }
    }, [priceContract]);
    
    async function handleMint() {
        if (window.ethereum) {
            const provider = new ethers.providers.Web3Provider(window.ethereum);
            const signer = provider.getSigner();
            const price = (await getPrice()).toString();
            const contract = new ethers.Contract(
                contractAddress,
                abi,
                signer
            );

            try {
                const response = await contract.mintPublic(BigNumber.from(mintAmount), {
                    value: utils.parseEther((price * mintAmount).toString()),
                });
                console.log('response: ', response);
            } catch(err) {
                console.log('error: ', err);
            }
        }
    }

    const handleDecrement = () => {
        if (mintAmount <= 1) return;
        setMintAmount(mintAmount - 1);
    };

    const handleIncrement = () => {
        if (mintAmount >= 20) return;
        setMintAmount(mintAmount + 1);
    };

    useEffect(() => {
        (async () => {
            const price = await getPrice();
            setPriceContract(price);
        })();
    }, []);
    
    return (
        <Flex
            justify='center'
            align='center'
            width='100%'
            position={isLargerThan800 ? 'absolute' : ''}
            top={isLargerThan800 ? '56%' : ''}
            transform={isLargerThan800 ? 'translateY(-50%)' : ''}
            paddingBottom={isLargerThan800 ? '' : '20px'}
        >
            <Box>
                <Flex justify='center' align='center' padding='20px' flexDirection={isLargerThan550 ? 'row' : 'column'}>
                    <Image
                        objectFit='contain'
                        borderRadius='20px'
                        borderStyle='solid'
                        borderColor='black'
                        boxSize={isLargerThan800 ? '380px' : '300px'}
                        src={mainImg}
                        alt='Civilian'
                    />
                    <Flex flexDirection='column'>
                        <UnorderedList
                            spacing= {32}
                            textAlign= 'left'
                            fontSize='20px'
                            marginBottom='25px'
                            >
                            <ListItem>2077 Animated Civilianz</ListItem>
                            <ListItem>Instant Reveal</ListItem>
                            <ListItem>Max 20 per TX</ListItem>
                            {listItem}
                        </UnorderedList>
                        {isConnected ? (
                        <div>
                            <Flex align='center' justify='center'>
                                <ButtonPress
                                    backgroundColor='#6a6e74'
                                    borderRadius='5px'
                                    boxShadow='2px 2px 2px 1px #0F0F0F'
                                    color='white'
                                    cursor='pointer'
                                    fontFamily='inherit'
                                    padding='15px'
                                    marginTop='10px'
                                    onClick={handleDecrement}
                                >
                                    -
                                </ButtonPress>
                                <Input
                                    readOnly
                                    fontFamily='inherit'
                                    width='100px'
                                    height='40px'
                                    textAlign='center'
                                    paddingLeft='19px'
                                    marginTop='10px'
                                    type='number'
                                    value={mintAmount}
                                />
                                <ButtonPress
                                    backgroundColor='#6a6e74'
                                    borderRadius='5px'
                                    boxShadow='2px 2px 2px 1px #0F0F0F'
                                    color='white'
                                    cursor='pointer'
                                    fontFamily='inherit'
                                    padding='15px'
                                    marginTop='10px'
                                    onClick={handleIncrement}
                                >
                                    +
                                </ButtonPress>
                            </Flex>
                            <ButtonPress
                                backgroundColor='#6a6e74'
                                borderRadius='5px'
                                boxShadow='2px 2px 2px 1px #0F0F0F'
                                color='white'
                                cursor='pointer'
                                fontFamily='inherit'
                                fontSize='20px'
                                padding='12px'
                                marginTop='10px'                            
                                onClick={handleMint}
                            >   
                                Mint
                            </ButtonPress>
                        </div>
                    ) : (
                        <p
                            fontSize='20px'
                            // padding={isLargerThan800 ? '20px 10px 20px 10px' : '0 10px 0 10px'}
                        >Please connect <br></br><br></br> your wallet.</p>
                    )}
                    </Flex>
                </Flex>
            </Box>
        </Flex>
    );
};

export default MainMint;